export default {
  title: 'Activer les réservations',
  buttons: {
    cancel: 'Annuler',
    activate: 'Activer les réservations',
  },
};
